import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationDynamicMasterReferenceData = createAsyncThunk(
  'stop/getVerificationDynamicMasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationDynamicMasterReferenceSlice = createSlice({
  name: 'stop/verificationDynamicMasterReference',
  initialState: null,
  reducers: {
    resetVerificationDynamicMasterReference: () => null,
  },
  extraReducers: {
    [getVerificationDynamicMasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationDynamicMasterReference } =
  verificationDynamicMasterReferenceSlice.actions;

export default verificationDynamicMasterReferenceSlice.reducer;
